export default {
  title: 'Encontre algo que adore!',
  description: 'Os seus pedidos serão listados aqui.',
  buttons: {
    order_now: 'Pedir agora',
  },
};
